<template>
  <t-enhanced-table
    ref="table"
    row-key="key"
    drag-sort="row-handler"
    :data="dataList"
    :columns="columns"
    :tree="{ childrenKey: 'children', expandTreeNodeOnClick: true}"
    :default-expand-all="false"
    :hover="true"
    :lazy-load="true"
    @expanded-tree-nodes-change="onExpandedChange"
  />
</template>
<script>
import {isPlainObject, get, cloneDeep} from 'lodash';

function travelGetRef(ref, jsonSchema) {
  // 最多循环10层，找不到则直接退出，避免死循环
  if(!ref || !ref.startsWith('#')) {
    return undefined;
  }
  let count = 10;
  while(count > 0) {
    count--;
    const path = ref.replace(/^(#\/)/gi, '').replace(/\//gi, '.');
    if(!path) {
      return undefined;
    }
    const newRef = get(jsonSchema, path);
    if(newRef?.$ref) {
      return travelGetRef(newRef.$ref, jsonSchema)
    } else {
      return newRef;
    }
  }
  return undefined;
}
// 这里传入一个childrenKey,用来来暂存children的数据，解决tdesign异步加载的数据带了children，同步展开的时候数据无法缩进的问题
function formatJsonSchemaToTable(jsonSchema, preKey = '0', rootJsonSchema, childrenKey = 'children') {
  let properties = jsonSchema.properties || [];
  let children = [];
  if(jsonSchema.$ref) {
    properties = [];
    const ref = travelGetRef(jsonSchema.$ref, rootJsonSchema);
    if(ref?.type) {
      jsonSchema.type = ref.type;
      children = true;
    }
  }
  if(jsonSchema.type === 'array') {
    let items = jsonSchema.items;
    if(isPlainObject(items)) {
      if(items.$ref) {
        items = travelGetRef(items.$ref, rootJsonSchema);
      }
      jsonSchema.type = `${jsonSchema.type} [${items.type}]`;
      if(items.type === 'object') {
        properties = items.properties || [];
      }
    }
  }
  if (properties) {
    let count = 0;
    for (const k of Object.keys(properties)) {
      const item = properties[k];
      const newKey = `${preKey}_${count}`;
      const newItem = formatJsonSchemaToTable(item, newKey, rootJsonSchema, childrenKey);
      children.push({
        key: newKey,
        name: k,
        ...newItem,
      });
      count++;
    }
  }
  if(children === true || children?.length) {
    if(childrenKey !== 'children'){
      jsonSchema.children = true;
      !jsonSchema.$ref && (jsonSchema[childrenKey] = children);
    } else {
      jsonSchema.children = children;
    }
  } else {
    jsonSchema[childrenKey] = undefined;
    jsonSchema.children = undefined;
  }
  return jsonSchema;
}


export default {
  props: {
    jsonSchema: {
      type: Object,
      default: ()=>({}),
    },
  },
  data() {
    return {
      originJsonSchema: {},
      dataList: [],
      columns: [
        {
          colKey: 'name',
          title: '参数',
          ellipsis: true,
        },
        {
          colKey: 'description',
          title: '名称',
          ellipsis: true,
        },
        {
          width: 180,
          colKey: 'type',
          title: '类型',
        },
      ],
    };
  },
  async mounted() {
    this.init();
  },
  watch: {
    jsonSchema() {
      this.init();
    }
  },
  methods: {
    init() {
      this.originJsonSchema = cloneDeep(this.jsonSchema);
      this.dataList = formatJsonSchemaToTable(this.jsonSchema, '0', this.jsonSchema)?.children || [];
    },
    onExpandedChange(expandedTreeNodes, context) {
      const tableRef = this.$refs.table;
      const jsonSchema = this.originJsonSchema;
      const row = context?.row;
      if(row.children === true) {
        if(row.tmpChildren) {
          setTimeout(()=>{
            tableRef.appendTo(row.key, row.tmpChildren);
          });
        } else if(row?.$ref) {
          const ref = travelGetRef(row.$ref, cloneDeep(jsonSchema));
          if(ref) {
            setTimeout(()=>{
              // 这里用tmpChildren来存children，解决tdesign异步加载的数据带了children，同步展开的时候数据无法缩进的问题
              const appendList = formatJsonSchemaToTable(ref, row.key,  cloneDeep(jsonSchema), 'tmpChildren')?.tmpChildren || [];
              tableRef.appendTo(row.key, appendList);
            });
          }
        }
      }
    },
  },
};
</script>
